import { getShortName, getCategoryById, getVehicleClassById, getDate } from 'services/types';
import { ParkingCell } from 'libs/ui';
import { getMeanType, getStatus, getTariff, getMeanValue } from './soall.consts';

export const getTableParams = (t) => {
  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  const getFields = () => {
    const fields = [
      { name: 'mean_type', title: t('dict_filter.Тип'), width: 110, sortField: 'mean_type', render: (val) => getMeanType(val) },

      { name: 'mean_id', title: t('grid.Номер СО'), width: 170, sortField: 'mean_id', render: (val, _, row) => getMeanValue(val, row) },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 170, sortField: 'vehicle_plate' },
      {
        name: 'is_blocked',
        title: t('grid.Статус') + ' / ' + t('dict_filter.Список'),
        width: 130,
        render: (_val, _, row) => getStatus(row),
      },
      {
        name: 'start_at',
        title: t('form.Дата действия с'),
        width: 210,
        sortField: 'start_at',
        render: (val) => getDate(val),
      },
      {
        name: 'end_at',
        title: t('form.Дата действия по'),
        width: 210,
        sortField: 'end_at',
        render: (val) => getDate(val),
      },
      { name: 'client_name', title: t('form.Клиент'), width: 145 },
      {
        name: 'vehicle_class',
        title: t('dict_filter.Класс ТС'),
        width: 160,
        sortField: 'vehicle_class',
        render: (val) => getVehicleClassById(val),
      },
      {
        name: 'vehicle_category',
        title: t('form.Категория'),
        width: 185,
        sortField: 'vehicle_category',
        render: (val) => getCategoryById(val),
      },
      { name: 'tariff', title: t('form.Тариф'), width: 180, render: (_val, _, row) => getTariff(row) },
      { name: 'owner', title: t('form.Держатель') + ' / ' + t('form.Инициатор'), sortField: 'owner', render: (val) => getShortName(val) },
      { name: 'comment', title: t('filter.Комментарий') + ' / ' + t('form.Причина внесения'), width: 205 },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 140,
      });
    }

    return fields;
  };

  return { getFields, getRowClass, withComment: true };
};
